<ng-template linkTemplate let-dataItem="dataItem">
    <div class="container">
        <wbo-edit-link [dataItem]="dataItem" [field]="field" [componentPath]="componentPath"
                       [editComponent]="editComponent" [editPath]="editPath"
                       [editParams]="editParams" [parentEntity]="parentEntity"
                       [editMode]="editMode"
                       (onSave)="dataItemSaved(dataItem, $event)"></wbo-edit-link>
        <fui-tags class="discontinued utility color-dusty-gray" *ngIf="showDiscontinued">
            <fui-tag *ngIf="(dataItem | property: componentPath).discontinued" [title]="'wbo.common.label.discontinued'">
                <fui-icon [height]="14" [icon]="'ban'" [width]="14"></fui-icon>
            </fui-tag>
        </fui-tags>
    </div>
</ng-template>
